<div class="audit-list-container">
  <app-table
    [data]="auditData"
    [columns]="auditColumns"
    [rows]="auditPageSize"
    [showPaginator]="true"
    [showSort]="false"
    [showFilter]="true"
    [loading]="auditLoading"
    [globalFilterFields]="auditGlobalFilterFields"
    [actions]="auditActions"
    [filterConfig]="auditFiltersConfig"
    [(filterValue)]="auditFiltersValue"
    (searchClicked)="onAuditSearchClicked($event)"
    [totalRecords]="auditTotalRecords"
    (lazyLoadData)="onLazyLoadEventFromTable($event)"
    [showExportButton]="true"
    (onExportClick)="handleExport()"
  >
  </app-table>
</div>
<dialog class="list-popup" [open]="listPopupVisible" [style.left.px]="listPopupX" [style.top.px]="listPopupY" aria-label="More items">
  <div class="popup-header">
    <span class="popup-title-header">{{ listPopupTitle }}</span>
    <button type="button" aria-label="Close" (click)="closeListPopup()">✕</button>
  </div>
  <ul class="popup-list">
    <li *ngFor="let c of listPopupItems">{{ c }}</li>
  </ul>
</dialog>

